import { memo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import ideaImage from "../Assets/Images/idea.svg";
import { Config } from "../constants/Config";
import type { TipTitle } from "../types/tips";

export interface TipsTricksCardProps {
  data: TipTitle;
}

const TipsTricksCard = ({ data }: TipsTricksCardProps) => {
  const share = (): void => {
    if (navigator.share) {
      void navigator.share({
        title: data.name,
        text: data.description[0].text,
        url: `${window.location.protocol}//${window.location.host}/tips`,
      });
    }
  };

  return (
    <div>
      {data.description.map((item, index) => (
        <div key={index} className="card shadow border-0 br-10px mb-5">
          <div className="row g-0">
            <div className="col-sm-3">
              <img
                src={item.image.replace(
                  Config.TIPS_THUMBNAIL,
                  Config.TIPS_THUMBNAIL_NEW
                )}
                className="img-fluid rounded-start w-100 h-100 object-cover"
                alt={data.name}
              />
            </div>
            <div className="col-sm-8">
              <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center mb-3">
                    <div className="flex-shrink-0">
                      <img src={ideaImage} alt="idea" />
                    </div>
                    <div className="flex-grow-1 ms-3 fw-bold font-18 text-light">
                      {data.name}
                    </div>
                  </div>
                  <div className="d-md-none sm_shareButton">
                    <FontAwesomeIcon
                      onClick={share}
                      icon={solid("share")}
                      className="text-white _hover cursor-pointer"
                    />{" "}
                  </div>
                </div>
                <p className="card-text font-14">{item.text}</p>
              </div>
            </div>

            <div
              className="tipsShare _hover cursor-pointer"
              onClick={share}
            >
              <FontAwesomeIcon icon={solid("share")} className="text-white" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(TipsTricksCard);
